/* eslint-disable max-len */
/**
 * Spanish translations.
 */
export default {
  ACTION: {},
  ERROR: {
    DELETE_TWITCH: 'Error al cancelar la integración con Twitch',
    ERROR: 'Error',
    FETCH_DATA: 'Recuperar datos'
  },
  HEADER: {
    DATE: 'Fecha',
    MESSAGE: 'Mensaje',
    NAME: 'Nombre',
    ORDER_CODE: 'Código de pedido',
    ORDER_VALUE: 'Importe'
  },
  LABEL: {
    ACTIVE_SINCE: 'Activo desde',
    INTEGRATIONS: 'Integraciones',
    TWITCH: 'Twitch',
    TWITCH_AUTH: 'Permisos Twitch',
    TWITCH_AUTHORIZED_INFORMATION:
      'Prozis tiene permiso para crear alertas en Twitch durante las transmisiones en directo.',
    TWITCH_INFORMATION:
      'Prozis solicitará permiso para crear alertas en Twitch durante las transmisiones en directo.',
    TWITCH_INTEGRATION: 'Integración con Twitch'
  },
  SENTENCE: {},
  SUCCESS: {
    DELETE_TWITCH: 'Integración con Twitch cancelada',
    SUCCESS: 'Acción realizada correctamente'
  },
  TOOLTIP: {
    ORDER_CODE: 'Código de pedido'
  }
};
